module.exports = __webpack_public_path__ + "img/self-help@2x.75dd0781.jpg";